<template>
    <v-container>
        <v-card slot="rightContainer" outlined>
            <v-card-title class="grey lighten-4">
                <b>LISTA DE ENTREGAS</b>
                <v-spacer />
                <v-col cols="12" sm="4">
                    <h5>
                        <v-btn class="mx-1" small color="green" dark @click="descargarArchivo"> DESCARGAR XLSX </v-btn>
                    </h5>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-menu
                        ref="menu"
                        v-model="menu3"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                    >
                        <template #activator="{ on, attrs }">
                            <v-text-field
                                v-model="fechaFiltro"
                                hide-details="auto"
                                dense
                                label="FILTRAR POR MES"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            />
                        </template>
                        <v-date-picker v-model="fechaFiltro" type="month" no-title scrollable>
                            <v-spacer />
                            <v-btn text color="primary" @click="menu3 = false"> CERRAR </v-btn>
                            <v-btn color="primary" :loading="loadingLista" @click="getLista"> BUSCAR </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <!-- <v-col cols="12" sm="3">
                    <v-text-field dense v-model="search" append-icon="mdi-magnify" label="BUSCAR" single-line hide-details />
                </v-col> -->
            </v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table multi-sort :search="search" :items="_listaEntregas" :headers="headers" class="elevation-1" :items-per-page="20">
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import { mapState } from 'vuex'
import { format, parseJSON } from 'date-fns'
import { exportXLSX } from '@/utils'

export default {
    data() {
        return {
            fechaFiltro: format(new Date(), 'yyyy-MM'),
            menu3: false,
            loadingLista: false,
            dataProducto: '',
            search: '',
            headers: [
                { text: 'ticket', value: 'ticket' },
                { text: 'fecha', value: 'date' },
                { text: 'vendedor', value: 'user' },
                { text: 'producto', value: 'items' },
                { text: 'forma entrega', value: 'formaEntrega' },
                { text: 'celular recibe', value: 'celularContacto' },
                { text: 'Nombre/Razon Social', value: 'full_name' },
                { text: 'direccion entrega', value: 'direccion' },
                { text: 'referencia', value: 'referencia' }
            ]
        }
    },
    computed: {
        ...mapState('ventas', ['listaEntregas']),
        ...mapState('utilities', ['tipoFormaEntrega']),
        ...mapState('users', ['allColaborador']),
        ...mapState('sedes', ['ubigeos']),
        _listaEntregas() {
            let newLista = []
            if (this.listaEntregas.length > 0) {
                this.listaEntregas.map((x) => {
                    const atributosParsed = x.atributos ? JSON.parse(x.atributos) : null
                    newLista.push({
                        ...x,
                        user: this.allColaborador.find((y) => y.id == x.idColaborador)?.nombres || 'No disponible',
                        ticket: `T-${x.id}`,
                        date: format(parseJSON(x.date), 'dd/MM/yyyy'),
                        items: atributosParsed && atributosParsed.nombreProducto ? atributosParsed.nombreProducto : x.productos || 'Producto no disponible',
                        formaEntrega: x.formaEntrega
                            ? `${this.tipoFormaEntrega.find((y) => y.id == x.formaEntrega)?.text} - ${this.getNombreDistrito(x.ubigeo)}`
                            : null
                    })
                })
            }
            return newLista
        }
    },
    methods: {
        getNombreDistrito(ubigeoId) {
            if (!ubigeoId || !this.ubigeos) return ''
            const ubigeo = this.ubigeos.find((w) => w.id == ubigeoId)
            return ubigeo ? ubigeo.name : ''
        },
        async getLista() {
            this.loadingLista = true
            await Promise.all([
                this.$store.dispatch('ventas/lsVentasEntregadas', { idEstado: 9, date: this.fechaFiltro }),
                this.$store.dispatch('users/allColaborador'),
                this.$store.dispatch('sedes/detailsAllUbigeo')
            ])
            this.loadingLista = false
            this.menu3 = false
        },
        descargarArchivo() {
            this.loadingLista = true
            const headers = ['ticket', 'date', 'user', 'items', 'formaEntrega', 'celularContacto', 'full_name', 'direccion', 'referencia']
            const filename = `Lista Entregas ${this.fechaFiltro}`
            exportXLSX({ headers, campos: headers, arrayData: this._listaEntregas }, { filename })
            this.loadingLista = false
        }
    },
    async mounted() {
        await this.getLista()
    }
}
</script>
